import Link from "next/link"
import React from "react"
import SignupForm from "@/components/pages/signup/SignupForm"
import LoggedOutLayout from "@/components/layouts/LoggedOutLayout"
import styles from "@/styles/LoggedOutLayout.module.scss"
import classNames from "classnames"
import typo from "@/styles/Typography.module.scss"
import dynamic from "next/dynamic"
import thumb from "public/animations/thumb.json"

const Lottie = dynamic(() => import('react-lottie-player/dist/LottiePlayerLight'), { ssr: false })

export default function SignupPage() {
  return (
    <LoggedOutLayout title="Sign Up">
      <main className={styles.body}>
        <div className={styles.left}>
          <Lottie 
            animationData={thumb} 
            style={{ height: 100, width: 100 }} 
            loop={false} 
            play
          />
          <div className={styles.text}>
            <h1 className={classNames(typo.h3)}>
              Try It Free
            </h1>
            <br />
            <p className={classNames(typo.large)}>
              Enjoy a 14-day free trial of NextMe when you sign up, no credit card required. Start delivering amazing waiting experiences for your guests today and join the next generation of businesses helping people make the most of their time.
            </p>
            <br />
            <p className={classNames(typo.large)}>
              Interested in a product tour?{" "}
              <Link href="https://www.nextmeapp.com/request-demo">
                <a className={styles.link} id="signupLink">
                  Book a Demo
                </a>
              </Link>
              <br />
              Existing 1.0 customer?{" "}
              <Link href="https://intercom.help/nextme-app/en/articles/8302887-how-can-i-switch-to-nextme-2-0">
                <a className={styles.link} id="signupLink">
                  Migrate to 2.0
                </a>
              </Link>
            </p>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p className={styles.textUnderFormSignup}>&zwj;</p>
          <SignupForm />
        </div>
      </main>
    </LoggedOutLayout>
  )
}
